// React 보다 먼저 평가되어야 하므로 가장 먼저 import 합니다
import '@nenana/util/app/util/disableReactPerformanceTrack';

// 앱 스타일($app/style.css)은 앱 조립 모듈이 가져옵니다. 시뮬레이션 앱은 시뮬레이션 폴더까지 스캔하는 자기 CSS 를 씁니다.
import '@vueron/kiska/style.css';

import { extend } from '@react-three/fiber';
import type { ComponentType } from 'react';
import * as ReactDOM from 'react-dom/client';

import { initializeEnv } from '@vueron/kiska/util';

import { registerDevCommandList } from '$app/devCommand';
import { initI18n } from '@nenana/util/app/i18n';
import { CustomPointsMaterial } from '$viewer/component/three/CustomPointMaterial';
import { CustomPointsMaterial2 } from '$viewer/component/three/CustomPointMaterial2';

type AppModule = { default: ComponentType };

/**
 * 앱을 부팅합니다. 앱 진입점(apps/<앱>/main.tsx)이 자기 조립 모듈(apps/<앱>/src/App)을 넘겨 한 번 호출합니다.
 * 조립 모듈은 첫 렌더 전 번역 로드와 함께 불러옵니다(docs/monorepo-migration.md 1e).
 */
export const bootstrap = (loadApp: () => Promise<AppModule>) => {
  // runtime-env.js(entrypoint.sh)가 주입한 window['VITE_*'] 런타임 값을 설정
  const runtimeEnv = Object.fromEntries(
    Object.keys(window)
      .filter(key => key.startsWith('VITE_'))
      .map(key => [key, (window as Record<string, unknown>)[key]]),
  );

  // 빌드타임 import.meta.env 위에 런타임 값을 덮어써 docker env 변경이 반영되도록 함
  initializeEnv({ ...import.meta.env, ...runtimeEnv });

  extend({ CustomPointsMaterial });
  extend({ CustomPointsMaterial2 });

  // 개발자용 콘솔 명령(window.__dev__*)을 등록합니다. 목록은 $app/devCommand.
  registerDevCommandList();

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  // 첫 렌더 전에 현재 언어 번역을 로드해 번역 키가 잠깐 보이지 않게 합니다.
  const main = async () => {
    const [{ default: App }] = await Promise.all([loadApp(), initI18n()]);

    root.render(<App />);
  };

  main();
};
